import { Button } from "@/components/ui/button";
import { View } from "@/components/ui/view";
import * as React from 'react';
import { Video, AVPlaybackStatus } from 'expo-av';

export default function VideoTest() {
  const video = React.useRef(null);
  const [status, setStatus] = React.useState({});
  return (
    <View className="flex-1 justify-center bg-secondary-50">
      <Video
        ref={video}
        style={{ width: 320, height: 200 }}
        source={{
          uri: 'https://d23dyxeqlo5psv.cloudfront.net/big_buck_bunny.mp4',
        }}
        useNativeControls
        resizeMode="contain"
        isLooping
        onPlaybackStatusUpdate={status => setStatus(() => status)}
      />
      <View className="flex-row justify-center items-center">
        <Button onPress={() => status.isPlaying ? video.current.pauseAsync() : video.current.playAsync()} >{status.isPlaying ? 'Pause' : 'Play'}</Button>
      </View>
    </View>
  );
}
